/* German Beauty stability layer */
(function(){
  function clearLegacyScroll(){
    if(!document.body.classList.contains('gb-menu-open')){
      document.body.style.removeProperty('overflow');
    }
    window.onscroll=null;
  }
  if(document.readyState==='loading'){
    document.addEventListener('DOMContentLoaded',clearLegacyScroll,{once:true});
  }else{clearLegacyScroll();}
  window.addEventListener('load',function(){window.onscroll=null;}, {once:true});
})();